import React, { useState } from 'react';
import './DeleteUserModal.css';

interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (email: string) => void;
  user: {
    username: string;
    email: string;
    first_name: string;
    last_name: string;
  };
  loading: boolean;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  user,
  loading
}) => {
  const [confirmedEmail, setConfirmedEmail] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    if (!confirmedEmail.trim()) {
      setError('Please enter the user\'s email address');
      return;
    }
    
    if (confirmedEmail.toLowerCase() !== user.email.toLowerCase()) {
      setError('Email does not match the user\'s email address');
      return;
    }
    
    onConfirm(confirmedEmail);
  };

  const handleClose = () => {
    setConfirmedEmail('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content delete-user-modal">
        <div className="modal-header">
          <h3>Delete User Account</h3>
          <button onClick={handleClose} className="modal-close">&times;</button>
        </div>
        
        <div className="modal-body">
          <div className="warning-section">
            <div className="warning-icon">⚠️</div>
            <h4>This action cannot be undone!</h4>
            <p>
              You are about to permanently delete the account for user:
            </p>
            <div className="user-info">
              <strong>{user.first_name} {user.last_name}</strong> ({user.username})
            </div>
            <p>This will delete:</p>
            <ul>
              <li>All user activities and data</li>
              <li>Chat messages and conversations</li>
              <li>Training applications and relationships</li>
              <li>All associated records</li>
            </ul>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="confirm-email">
                To confirm deletion, please type the user's email address:
              </label>
              <input
                id="confirm-email"
                type="email"
                value={confirmedEmail}
                onChange={(e) => setConfirmedEmail(e.target.value)}
                placeholder="Enter user's email address"
                required
                disabled={loading}
              />
              <small className="help-text">
                User's email: <strong>{user.email}</strong>
              </small>
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <div className="modal-actions">
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-secondary"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-danger"
                disabled={loading || !confirmedEmail.trim()}
              >
                {loading ? 'Deleting...' : 'Delete User Account'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserModal; 